import { createAction } from 'redux-actions';
import { SET_SELECTED_TEAM } from './actionTypes';

export const setSelectedTeam = createAction<string>(SET_SELECTED_TEAM);
